import { restaurantTypesUrl } from './resources.js'
import common from './common.js'

//
//Always get current restaurant from the store
//
async function getAllRestaurantTypes() {
    let url = `${restaurantTypesUrl}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.restaurantTypes });
    return data;
}



export default {
    name: 'restauranttypesService',
    getAllRestaurantTypes
}